import { Flag, PublishFlagObject } from '@ffx/common';

export const compareFlagProperties = (ogFlags: Flag[], newFlag: Flag): boolean => {
    const matchingOgFlag = ogFlags.find((ogFlag) => ogFlag.id === newFlag.id);

    // If no matching flag is found, it's a new or deleted flag
    if (!matchingOgFlag) {
        return true;
    }

    if (
        // might want to trim off spaces before comparing?
        matchingOgFlag.key !== newFlag.key ||
        matchingOgFlag.status !== newFlag.status ||
        matchingOgFlag.name !== newFlag.name ||
        matchingOgFlag.description !== newFlag.description ||
        matchingOgFlag.labels.length !== newFlag.labels.length
    ) {
        return true;
    }

    return newFlag.labels.some(
        (label) =>
            !matchingOgFlag.labels.some(
                (ogLabelIcon) => ogLabelIcon.icon === label.icon && ogLabelIcon.name === label.name
            )
    );
};

export const getFlagArrayDifferences = (ogFlags: Flag[], newFlags: Flag[]): PublishFlagObject => {
    const flagsToUpdateAdd = newFlags.filter((newFlag) => {
        return compareFlagProperties(ogFlags, newFlag);
    });

    const flagsToDelete = ogFlags.filter((ogFlag) => !newFlags.some((newFlag) => newFlag.id === ogFlag.id));

    return {
        flagsToUpdateAdd,
        flagsToDelete
    };
};

export const getFlagInCurrentEnv = (flags: Flag[], flag: Flag): Flag => {
    return (
        flags.find((orgFlag) => orgFlag.key === flag.key) ?? {
            id: '',
            name: '',
            key: '',
            description: '',
            labels: [],
            status: false
        }
    );
};
